import { render, staticRenderFns } from "./WonderYjjPopular2.vue?vue&type=template&id=60642b2a"
import script from "./WonderYjjPopular2.vue?vue&type=script&lang=js"
export * from "./WonderYjjPopular2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports